/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Variability_Index_One_LinerInputs */

const en_exp_variability_index_one_liner = /** @type {(inputs: Exp_Variability_Index_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How steady your power was — Normalized Power divided by average power.`)
};

const de_exp_variability_index_one_liner = /** @type {(inputs: Exp_Variability_Index_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie gleichmäßig deine Leistung war — Normalisierte Leistung geteilt durch deine mittlere Leistung.`)
};

/**
* | output |
* | --- |
* | "How steady your power was — Normalized Power divided by average power." |
*
* @param {Exp_Variability_Index_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_variability_index_one_liner = /** @type {((inputs?: Exp_Variability_Index_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Variability_Index_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_variability_index_one_liner(inputs)
	return de_exp_variability_index_one_liner(inputs)
});